import Header from "../components/Header";
import { motion } from "motion/react";
import { routeVariants } from "../routesVariants";
import {
  Accordion,
  AccordionContent,
  AccordionSummary,
  Text,
  Title,
} from "../uikit";

import SupportContacts from "../components/SupportContacts";
import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import { DOMAIN } from "../consts";
import { lang } from "../i18n";
import styles from "./support.module.css";

export default function Support() {
  const [openIndex, setOpenIndex] = useState(null);
  const [faq, setFaq] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    let cancelled = false;

    fetch(DOMAIN + "/faq")
      .then((response) => response.json())
      .then((result) => {
        if (!cancelled && result.success) {
          setFaq(result.items ?? []);
        }
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <motion.div
      className="container background-regular column-spacing border-padding column"
      variants={routeVariants}
      initial="initial"
      animate="final"
      exit="exit"
    >
      <Header isBack={true}>
        <Title level="1" weight="3">
          {t("Support")}
        </Title>
      </Header>
      <div className="row header">
        <Text weight="2">{t("Support contacts")}</Text>
      </div>
      <SupportContacts/>
      {faq.length > 0 && (
        <>
          <div className="row header">
            <Text weight="2">{t("FAQ")}</Text>
          </div>
          <div>
            {faq.map((item, index) => (
              <Accordion
                key={item.id}
                expanded={openIndex === index}
                onChange={(expanded) => setOpenIndex(expanded ? index : null)}
              >
                <AccordionSummary multiline>
               	  {i18n.language === "ru" ? item.question_ru : item.question_en}
                </AccordionSummary>
                <AccordionContent>
                  <div className={`p-1 ${styles["faq-answer"]}`}>
                    {i18n.language === "ru" ? item.answer_ru : item.answer_en}
		  </div>
                </AccordionContent>
              </Accordion>
            ))}
          </div>
        </>
      )}
    </motion.div>
  );
}
